
import faq from "./components/faq";
import flickity from "./components/flickity";
import formsActive from "./components/formsActive";
import glightbox from "./components/glightbox";
import hambuger from "./components/hambuger";
import lazyLoad from "./components/lazy-load";
import loading from "./components/loading";
import subHeader from "./components/subHeader";
import bookings from "./apps/booking";
import applyButtonClick from "./components/applyButtonClick";

document.addEventListener("DOMContentLoaded", () => {
  hambuger();
  subHeader();
  lazyLoad();
  loading();
  formsActive();
  flickity();
  faq();
  glightbox();
  bookings();
  applyButtonClick();
});
